import React, { useState, useEffect } from 'react';
import { Navigate, NavigateProps } from 'react-router-dom';
import { supabase } from '../lib/supabase';

// Componentes das páginas
import LandingPage from '../pages/LandingPage';
import ThankYouPage from '../pages/ThankYouPage';
import LessonsPage from '../pages/LessonsPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import BioPage from '../pages/BioPage';
import LaunchLandingPage from '../pages/LaunchLandingPage';
import DocsPage from '../pages/DocsPage';
import SurveyPage from '../pages/SurveyPage';

// Mapeamento de componentes
const componentMap = {
  'LandingPage': LandingPage,
  'ThankYouPage': ThankYouPage,
  'LessonsPage': LessonsPage,
  'PrivacyPolicyPage': PrivacyPolicyPage,
  'BioPage': BioPage,
  'DocsPage': DocsPage,
  'LaunchLandingPage': LaunchLandingPage,
  'SurveyPage': SurveyPage,
  'Navigate': Navigate
} as const;

type ComponentProps = {
  Navigate: NavigateProps;
  [key: string]: any;
};

export interface RouteConfig {
  id: string;
  path: string;
  component: keyof typeof componentMap;
  props?: ComponentProps[keyof ComponentProps];
  title?: string;
  description?: string;
  is_active: boolean;
  priority: number;
  element?: React.ReactNode;
}

export function useRoutes() {
  const [routes, setRoutes] = useState<RouteConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const { data, error } = await supabase
          .from('routes')
          .select('*')
          .eq('is_active', true)
          .order('priority', { ascending: true });

        if (error) throw error;

        setRoutes(data || []);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Erro ao carregar rotas'));
      } finally {
        setLoading(false);
      }
    };

    fetchRoutes();
  }, []);

  // Converte as configurações de rota em elementos React
  const routeElements = routes.map(route => {
    const Component = componentMap[route.component];
    return {
      ...route,
      element: route.component === 'Navigate' 
        ? <Navigate to={(route.props?.to as string) || '/'} replace={route.props?.replace || false} />
        : Component 
          ? <Component {...(route.props || {})} />
          : null
    };
  });

  return { routes: routeElements, loading, error };
}

export default useRoutes; 